const defaultState = {
  order: "descend",
  columnKey: "population"
};

const slider = (state = defaultState, action) => {
  switch (action.type) {
    case "TABLE_CHANGE":
      return { order: action.order, columnKey: action.columnKey };
    default:
      return state;
  }
};

export default slider;



// WEBPACK FOOTER //
// ./src/reducers/sorter.js